// loadingOverlay.ts

interface LoadingOverlay {
  show: () => void;
  hide: () => void;
}

export const loadingOverlay: LoadingOverlay = (() => {
  let overlayElement: HTMLDivElement | null = null;

  function createOverlay(): HTMLDivElement {
    const overlay = document.createElement("div");
    overlay.id = "loading-overlay";
    overlay.style.cssText = `
        position: fixed;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background-color: rgba(0, 0, 0, 0.5);
        display: flex;
        justify-content: center;
        align-items: center;
        z-index: 9999;
      `;

    const spinner = document.createElement("div");
    spinner.className = "spinner";
    spinner.style.cssText = `
        width: 50px;
        height: 50px;
        border: 5px solid #f3f3f3;
        border-top: 5px solid #3498db;
        border-radius: 50%;
        animation: spin 1s linear infinite;
      `;

    const keyframes = `
        @keyframes spin {
          0% { transform: rotate(0deg); }
          100% { transform: rotate(360deg); }
        }
      `;
    const style = document.createElement("style");
    style.appendChild(document.createTextNode(keyframes));
    document.head.appendChild(style);

    overlay.appendChild(spinner);
    return overlay;
  }

  return {
    show: (): void => {
      if (!overlayElement) {
        overlayElement = createOverlay();
      }
      document.body.appendChild(overlayElement);
    },
    hide: (): void => {
      if (overlayElement && overlayElement.parentNode) {
        overlayElement.parentNode.removeChild(overlayElement);
      }
    },
  };
})();
